import { render, staticRenderFns } from "./DownloadComponent.vue?vue&type=template&id=76ec31fd&scoped=true&"
import script from "./DownloadComponent.vue?vue&type=script&lang=js&"
export * from "./DownloadComponent.vue?vue&type=script&lang=js&"
import style0 from "./DownloadComponent.vue?vue&type=style&index=0&id=76ec31fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec31fd",
  null
  
)

export default component.exports